import { useTranslation } from 'react-i18next';
import type { InvoiceStatus } from '@shared/api/contracts';
import { getInvoiceStatusVariant, INVOICE_STATUS_VARIANT_CLASSES } from '../lib/status';
import { cn } from '@shared/lib/utils';

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
  className?: string;
}

export function InvoiceStatusBadge({ status, className }: InvoiceStatusBadgeProps) {
  const { t } = useTranslation('cabinet');
  const variant = getInvoiceStatusVariant(status);
  const label = t(`payments.status.${status}`, { defaultValue: status });

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        INVOICE_STATUS_VARIANT_CLASSES[variant],
        className
      )}
    >
      {label}
    </span>
  );
}
